<template>
  <div class="personal-center">
    
    <el-tabs v-model="activeName" class="tabs" @tab-click="handleClick">
      <el-tab-pane label="账户信息" name="first">
        <div class="account-section">
          <div class="info-edit-wrap">
            <div class="userinfo-avatar">
              <el-upload
                action="#"
                :show-file-list="false"
                :on-change="handleAvatarChange"
                :auto-upload="true"
              >
                <div class="avatar-edit">
                  <img v-if="userForm.headPortrait || avatarUrl" :src="userForm.headPortrait || avatarUrl" class="avatar-img" />
                  <i v-else class="fa-regular fa-image avatar-icon"></i>
                  <span class="avatar-edit-text">点击头像修改</span>
                </div>
              </el-upload>
              <div class="user-balance">
                <el-icon class="power-icon"><Coin /></el-icon>
                <span>{{ userStore.totalAmount }} 点数</span>
              </div>
            </div>
            <div class="info-form">
              <el-form :model="userForm" :rules="userRules" ref="userFormRef" label-width="0" class="userinfo-form-inner">
                <el-form-item prop="name" class="form-group">
                  <label class="form-label">昵称</label>
                  <el-input v-model="userForm.name" class="form-input-lg" />
                </el-form-item>
                <el-form-item prop="accountNo" class="form-group">
                  <label class="form-label">邮箱</label>
                  <el-input v-model="userForm.accountNo" class="form-input-lg" />
                </el-form-item>
                <div class="form-group phone-form-group">
                  <label class="form-label">手机号</label>
                  <div class="phone-display-row">
                    <span class="phone-display-value">{{ userForm.mobilePhone || '未绑定' }}</span>
                    <el-button type="primary" link @click="openPhoneDialog">{{ userForm.mobilePhone ? '修改' : '绑定' }}</el-button>
                  </div>
                </div>
                <div class="info-actions">
                  <el-button type="danger" @click="handleLogout" >退出登录</el-button>
                  <el-button type="primary" @click="updateUserInfo" >保存修改</el-button>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="修改密码" name="second">
        <div class="account-section">
          <div class="form-container">
            <el-form :model="passwordForm" :rules="passwordRules" ref="passwordFormRef" label-width="0" class="password-form">
              <el-form-item prop="oldPwd" class="form-group">
                <label class="form-label">原密码</label>
                <el-input v-model="passwordForm.oldPassword" type="password" show-password class="form-input-lg" placeholder="请输入原密码" />
              </el-form-item>
              <el-form-item prop="newPwd" class="form-group">
                <label class="form-label">新密码</label>
                <el-input v-model="passwordForm.newPassword" type="password" show-password class="form-input-lg" placeholder="请输入新密码" />
              </el-form-item>
              <el-form-item prop="confirmPwd" class="form-group">
                <label class="form-label">确认新密码</label>
                <el-input v-model="passwordForm.confirmPassword" type="password" show-password class="form-input-lg" placeholder="请再次输入新密码" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="changePassword" class="btn-submit">确认修改</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="账户流水" name="third">
        <div class="account-section">
          <div class="section-title-row">
            <div class="filter-bar">
              <el-select v-model="filterType" placeholder="业务类型" size="default" style="width: 120px;">
                <el-option label="全部" value="" />
                <el-option label="充值" value="1" />
                <el-option label="消费" value="2" />
                <el-option label="赠送" value="3" />
                <el-option label="退款" value="4" />
              </el-select>
              <el-date-picker
                v-model="filterDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="default"
                style="margin: 0 8px; width: 240px;"
              />
              <el-button type="primary" size="default" @click="onSearch">搜索</el-button>
            </div>
          </div>
          <div class="table-scroll-area">
            <el-table :data="filteredAccountList" height="100%" stripe class="account-table">
              <el-table-column prop="serialNum" label="流水号" min-width="180" />
              <el-table-column prop="changeTime" label="创建时间" min-width="100" />
              <el-table-column prop="type" label="业务类型" min-width="60">
                <template #default="{ row }">
                  {{ getChangeTypeText(row.changeType) }}
                </template>
              </el-table-column>
              <el-table-column prop="changeDesc" label="业务方式" min-width="150">
                <template #default="{ row }">
                  {{ row.changeDesc === '模板管理视频解析' ? '爆款模版 视频解析' : row.changeDesc }}
                </template>
              </el-table-column>
              <el-table-column prop="changeAmount" label="点数变动" min-width="80">
                <template #default="{ row }">
                  <span :class="(row.changeType === 1 || row.changeType === 3) ? 'amount-plus' : 'amount-minus'">{{ (row.changeType === 1 || row.changeType === 3) ? '+' : '-' }}{{ row.changeAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="balancePower" label="变动后余额" min-width="110">
                <template #default="{ row }">
                  {{ row.balancePower ?? '--' }}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-wrapper">
            <Pagination
              v-if="total > 0"
              :total="total"
              :current-page="page"
              :page-size="limit"
              :page-sizes="[20, 50, 100]"
              @page-change="handlePageChange"
              @size-change="handleSizeChange"
            />
          </div>
        </div>
      </el-tab-pane>
      
      
      <el-tab-pane label="点数充值" name="fourth">
        <div class="account-section">
          <div class="user-balance">
            当前可用：
            <el-icon class="power-icon"><Coin /></el-icon>
            <span>{{ userStore.totalAmount }} 点数</span>
          </div>
          <div class="recharge-cards-group">
            <div v-for="card in powerCards" :key="card.id" class="recharge-card" :class="{ active: selectedPayCard && selectedPayCard.id === card.id }" @click="selectPayCard(card)">
              <div class="rc-title">{{ card.packageName }}w<span v-if="card.giveMoney" class="rc-tag">+{{ card.packageName * (card.giveMoney/10) }}K</span></div>
              <div class="rc-price">¥ {{ card.rechargeMoney }}</div>
              <div class="rc-badge-bottom" v-if="card.remark || card.giveMoney">
                <span v-if="card.remark" class="badge-yellow">{{ card.remark }}</span>
                <span v-if="card.giveMoney" class="badge-yellow" style="opacity: 0.8;">额外赠送 {{ card.giveMoney }}%</span>
              </div>
            </div>
            
          </div>
          
          <div class="pay-method-area">
            <div class="pay-method-group">
              <el-radio-group v-model="payMethod">
                <el-radio value="alipay">
                  <span style="color: #0EA5E9;">
                    <i class="fa-brands fa-alipay"></i> 支付宝
                  </span>
                </el-radio>
                <el-radio value="wechat">
                  <span style="color: #22C55E;">
                    <i class="fa-brands fa-weixin"></i> 微信
                  </span>
                </el-radio>
              </el-radio-group>
            </div>
            <el-button type="primary" class="pay-btn-lg" @click="confirmPay">确认支付</el-button>
          </div>
          <div class="scale-user-card power-card-dark" @click="contactCustomer">
            <div class="rc-title" style="color: #FCD34D;">规模用户</div>
            <div style="font-size: 13px; margin-top: 4px; color: #D1D5DB;">获得额外折扣</div>
            <div class="rc-badge-bottom" style="margin-top: 10px;">
              <span class="badge-yellow" style="background: #FCD34D; color: #374151;">联系客服</span>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      v-model="showPayModal"
      title="扫码支付"
      width="480px"
      :close-on-click-modal="false"
      :show-close="true"
      center
    >
      <div class="pay-modal">
        <div class="pay-order">
          <img
            v-if="payCard?.payMethod === 'wechat' && payQRCode"
            :src="payQRCode"
            alt="微信二维码"
            class="pay-qrcode"
          />
          <div v-if="payCard?.payMethod === 'wechat'">
            <div class="pay-info">
              <div>订单编号：{{ payCard?.orderId }}</div>
              <div>点数值到账：{{ payDisplayPower }}w（永久）</div>
              <div>支付方式：微信</div>
              <div class="pay-amount">订单金额：<span class="pay-amount-value">￥{{ payDisplayAmount }}</span></div>
            </div>
          </div>
        </div>
        <div class="pay-tip" v-if="payCard?.payMethod === 'wechat'">【温馨提示】：点数值为平台虚拟商品，购买后不可退款。</div>
      </div>
    </el-dialog>

    <!-- 修改手机号弹窗 -->
    <el-dialog v-model="phoneDialogVisible" title="修改手机号" width="420px" :close-on-click-modal="false" append-to-body>
      <el-form :model="phoneForm" :rules="phoneRules" ref="phoneFormRef" label-width="80px">
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="phoneForm.phone" placeholder="请输入手机号" class="form-input-lg" />
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div class="phone-code-row">
            <el-input v-model="phoneForm.code" placeholder="请输入验证码" class="form-input-lg" />
            <el-button
              type="primary"
              :disabled="codeSending || phoneCountdown > 0"
              @click="sendPhoneCode"
              style="margin-left: 8px; white-space: nowrap;"
            >{{ phoneCountdown > 0 ? `${phoneCountdown}s后重发` : '发送验证码' }}</el-button>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="phoneDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitPhone">确定</el-button>
      </template>
    </el-dialog>
    <PaymentUnavailableDialog v-model="showPaymentUnavailable" />
  </div>
</template>

<script setup>
import { ref, onMounted, computed, onUnmounted, watch, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Coin, User, Delete } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useUserStore } from '@/stores/portal/user'
import logoImg from '@/apps/portal/assets/logo.jpg'
import qrImg from '@/apps/portal/assets/qr.jpg'
import { updateUserInfo as updateUserInfoApi, changePassword as changePasswordApi, updateHeadPortrait, sendVerificationCode, logout as logoutApi } from '@/api/portal/user'
import { getRechargePackageList } from '@/api/portal/mall'
import { getAccountLogList } from '@/api/portal/fin'
import { createRecOrder, getWxPayParams, queryWxPayOrder, getAlipayParams, queryAlipayOrder } from '@/api/portal/order'
import QRCode from 'qrcode'
import Pagination from '@/apps/portal/components/Pagination.vue'
import PaymentUnavailableDialog from '@/apps/portal/components/PaymentUnavailableDialog.vue'

const emit = defineEmits(['close'])
const route = useRoute()
const router = useRouter()
const userStore = useUserStore()
const showPaymentUnavailable = ref(false)

function blockUnavailablePayment() {
  showPaymentUnavailable.value = true
  return true
}

// tab切换
const allowedTabs = new Set(['first', 'second', 'third', 'fourth'])
const requestedTab = String(route.query.tab || '')
const activeName = ref(allowedTabs.has(requestedTab) ? requestedTab : 'first')

function handleClick(tab) {
  console.log(tab)
}

function showMoreCards() {
  //ElMessage.success('更多充值功能演示：')
  activeName.value = 'fourth'
}

// 购买点数卡片数据
const powerCards = ref([])

// 获取充值套餐列表
const getPowerCards = async () => {
  try {
    const res = await getRechargePackageList()
    if (res.code === 0) {
      const list = (res.list || []).filter((item) => item.recType !== 1)
      powerCards.value = list.map(item => ({
        ...item,
        packageName: item.packageName ?? item.package_name,
        rechargeMoney: item.rechargeMoney ?? item.recharge_money,
        actPower: item.actPower ?? item.act_power,
        recommend: item.recommend === 1
      }))
    }
  } catch (error) {
    ElMessage.error('获取充值套餐失败')
  }
}


// 筛选相关
const filterType = ref('')
const filterDateRange = ref([])
const accountList = ref([])
const page = ref(1)
const limit = ref(20)
const total = ref(0)

// 获取账户流水列表（分页）
const getAccountList = async () => {
  try {
    const params = {
      page: page.value,
      limit: limit.value,
      changeType: filterType.value,
      startTime: filterDateRange.value?.[0],
      endTime: filterDateRange.value?.[1]
    }
    const res = await getAccountLogList(params)
    if (res.code === 0 && res.page) {
      accountList.value = res.page.list || []
      total.value = res.page.total || 0
    }
  } catch (error) {
    ElMessage.error('获取账户流水失败')
  }
}

const filteredAccountList = computed(() => {
  return accountList.value
})

function onSearch() {
  page.value = 1
  getAccountList()
}

function handlePageChange(val) {
  page.value = val
  getAccountList()
}

function handleSizeChange(val) {
  limit.value = val
  page.value = 1
  getAccountList()
}

// 业务类型转换
const getChangeTypeText = (type) => {
  const typeMap = {
    1: '充值',
    2: '消费',
    3: '赠送',
    4: '退款'
  }
  return typeMap[type] || '未知'
}

// 修改密码表单
const passwordForm = ref({ oldPassword: '', newPassword: '', confirmPassword: '' })
const passwordFormRef = ref()
const passwordRules = {
  oldPassword: [ { required: true, message: '请输入原密码', trigger: 'blur' } ],
  newPassword: [ { required: true, message: '请输入新密码', trigger: 'blur' } ],
  confirmPassword: [
    { required: true, message: '请确认新密码', trigger: 'blur' },
    { validator: (rule, value, callback) => {
        if (value !== passwordForm.value.newPwd) {
          callback(new Error('两次输入密码不一致'))
        } else {
          callback()
        }
      }, trigger: 'blur' }
  ]
}
// 修改密码
const changePassword = async () => {
  if (passwordForm.value.newPassword !== passwordForm.value.confirmPassword) {
    ElMessage.error('两次输入的密码不一致')
    return
  }
  try {
    await changePasswordApi({
      oldPassword: passwordForm.value.oldPassword,
      password: passwordForm.value.newPassword,
      confirmPassword: passwordForm.value.confirmPassword
    })
    ElMessage.success('密码修改成功')
    passwordForm.value = {
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    }
  } catch (error) {
    ElMessage.error(error.message || '密码修改失败')
  }
}
// 更新用户信息
const updateUserInfo = async () => {
  try {
    await updateUserInfoApi(userForm.value)
    ElMessage.success('更新成功')
  } catch (error) {
    ElMessage.error(error.message || '更新失败')
  }
}

const avatarUrl = logoImg
// 账户信息表单
const userForm = ref({
  accountNo: '',
  name: '',
  mobilePhone: '',
  headPortrait: '',
  totalAmount: 0
})
const userFormRef = ref()
const userRules = {
  email: [ { required: true, message: '请输入邮箱', trigger: 'blur' }, { type: 'email', message: '邮箱格式不正确', trigger: 'blur' } ],
  nickname: [ { required: true, message: '请输入昵称', trigger: 'blur' } ],
  phone: [ { required: true, message: '请输入电话号码', trigger: 'blur' } ]
}
function submitUserInfo() {
  userFormRef.value.validate(valid => {
    if (valid) {
      ElMessage.success('信息修改成功！')
    }
  })
}
async function handleAvatarChange(file) {
  const formData = new FormData()
  formData.append('file', file.raw)
  try {
    await updateHeadPortrait(formData)
    //ElMessage.success('头像上传成功')
    // 重新获取用户信息
    const userInfo = await userStore.getUserInfo()
    if (userInfo) {
      userForm.value = { ...userInfo }
    }
  } catch (e) {
    ElMessage.error(e.message || '头像上传失败')
  }
}
// 修改手机号
const phoneDialogVisible = ref(false)
const phoneForm = ref({ phone: '', code: '' })
const phoneFormRef = ref()
const codeSending = ref(false)
const phoneCountdown = ref(0)
let phoneCountdownTimer = null
const phoneRules = {
  phone: [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
  ],
  code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
}
function openPhoneDialog() {
  phoneForm.value = { phone: userForm.value.mobilePhone || '', code: '' }
  phoneDialogVisible.value = true
}
async function sendPhoneCode() {
  if (!phoneForm.value.phone) {
    ElMessage.warning('请先输入手机号')
    return
  }
  if (!/^1[3-9]\d{9}$/.test(phoneForm.value.phone)) {
    ElMessage.warning('请输入正确的手机号')
    return
  }
  codeSending.value = true
  try {
    await sendVerificationCode(phoneForm.value.phone)
    ElMessage.success('验证码已发送')
    phoneCountdown.value = 60
    phoneCountdownTimer = setInterval(() => {
      phoneCountdown.value--
      if (phoneCountdown.value <= 0) {
        clearInterval(phoneCountdownTimer)
      }
    }, 1000)
  } catch (e) {
    ElMessage.error(e.message || '发送失败')
  } finally {
    codeSending.value = false
  }
}
function submitPhone() {
  phoneFormRef.value.validate(async (valid) => {
    if (!valid) return
    try {
      await updateUserInfoApi({ mobilePhone: phoneForm.value.phone, verificationCode: phoneForm.value.code })
      userForm.value.mobilePhone = phoneForm.value.phone
      phoneDialogVisible.value = false
      clearInterval(phoneCountdownTimer)
      phoneCountdown.value = 0
      ElMessage.success('手机号修改成功')
    } catch (e) {
      ElMessage.error(e.message || '手机号修改失败')
    }
  })
}

// 退出登录
const handleLogout = async () => {
  try {
    await logoutApi()
  } catch {
    // 请求拦截器已经展示失败原因；服务端未确认退出时保留当前会话供用户重试。
    return
  }

  userStore.logout()
  
  // 显示退出成功提示
  ElMessage.success('已退出登录')
  
  // 关闭个人中心弹窗
  emit('close')
  
  // 延迟2秒后跳转，让用户看到成功提示
  setTimeout(() => {
    // 跳转到首页，显示"全部"菜单
    // 使用replace确保路由历史正确，并强制刷新页面状态
    router.replace('/').then(() => {
      // 强制刷新页面以确保状态完全重置
      window.location.reload()
    })
  }, 1000)
}

// 联系客服
const contactCustomer = () => {
  ElMessageBox.alert(
    `<div style="text-align: center;">
      <img src="${qrImg}" alt="客服二维码" style="width: 200px; height: 272px; margin-bottom: 16px;" />
      <p style="color: #666; font-size: 14px;">扫描二维码联系客服</p>
       <p style="color: #666; font-size: 14px;">Email:support@elemagix.com</p>
    </div>`,
    '联系客服',
    {
      confirmButtonText: '关闭',
      dangerouslyUseHTMLString: true,
      customClass: 'customer-service-dialog',
      center: true
    }
  )
}

// 清除缓存
const clearCache = () => {
  ElMessageBox.confirm(
    '确定要清除系统缓存吗？\n\n这将清除：\n• 用户登录信息\n• 页面状态数据\n• 上传文件记录\n• 处理进度缓存\n\n清除后需要重新登录。',
    '清除系统缓存',
    {
      confirmButtonText: '确定清除',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'custom-message-box'
    }
  ).then(() => {
    // 清除所有localStorage数据
    localStorage.clear()
    
    // 清除sessionStorage（如果有）
    sessionStorage.clear()
    
    // 清除cookies（如果有）
    document.cookie.split(";").forEach(function(c) { 
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
    })
    
    ElMessage.success('系统缓存已清除，页面即将刷新...')
    
    // 延迟刷新页面
    setTimeout(() => {
      window.location.reload()
    }, 1500)
  }).catch(() => {
    ElMessage.info('已取消清除缓存')
  })
}
const showPayModal = ref(false)
const payCard = ref(null)
const payDisplayPower = computed(() => {
  const p = payCard.value
  if (!p) return ''
  return p.packageName != null && p.packageName !== '' ? p.packageName : ''
})
const payDisplayAmount = computed(() => {
  const p = payCard.value
  if (!p) return ''
  return p.rechargeMoney != null && p.rechargeMoney !== '' ? p.rechargeMoney : ''
})
const payQRCode = ref('')
const paymentPollingTimer = ref(null)
const currentOrderId = ref(null)
const selectedPayCard = ref(null)
const payMethod = ref('alipay')

function stopPaymentPolling() {
  if (paymentPollingTimer.value) {
    clearInterval(paymentPollingTimer.value)
    paymentPollingTimer.value = null
  }
}

async function checkPaymentStatus() {
  if (!currentOrderId.value) return
  let res
  if (payMethod.value === 'wechat') {
    res = await queryWxPayOrder(currentOrderId.value)
    const { tradeState } = res.msg || {}
    if (tradeState === 'SUCCESS') {
      stopPaymentPolling()
      showPayModal.value = false
      router.push({ path: '/payment/result', query: { orderId: currentOrderId.value, paymentMethod: 'wechat' } })
    }
  } else if (payMethod.value === 'alipay') {
    res = await queryAlipayOrder(currentOrderId.value)
    const { data } = res
    if (data && (data.payStatus === 'PAID' || data.payStatus === 'COMPLETED' || data.payInfoStatus === 'TRADE_SUCCESS')) {
      stopPaymentPolling()
      showPayModal.value = false
      router.push({ path: '/payment/result', query: { orderId: currentOrderId.value, paymentMethod: 'alipay' } })
    }
  }
}

function startPaymentPolling() {
  stopPaymentPolling()
  paymentPollingTimer.value = setInterval(() => {
    checkPaymentStatus()
  }, 3000)
}

async function confirmPay() {
  if (blockUnavailablePayment()) return
  const card = selectedPayCard.value
  if (!card) {
    ElMessage.warning('请先选择充值套餐')
    return
  }
  const pkgId = card.id
  const amount = card.rechargeMoney ?? card.recharge_money
  const power = card.actPower ?? card.act_power
  if (pkgId == null || amount == null || amount === '' || power == null) {
    ElMessage.warning('套餐数据异常，请刷新页面后重试')
    return
  }
  try {
    const orderParams = {
      packageId: pkgId,
      amount,
      payType: payMethod.value,
      power
    }
    const res = await createRecOrder(orderParams)
    if (res.code !== 0 || !res.orderId) {
      ElMessage.error(res.message || '创建订单失败')
      return
    }
    currentOrderId.value = res.orderId
    payCard.value = {
      packageName: card.packageName ?? card.package_name,
      rechargeMoney: amount,
      actPower: power,
      payMethod: payMethod.value,
      orderId: res.orderId
    }
    if (payMethod.value === 'wechat') {
      const wxRes = await getWxPayParams(res.orderId)
      const codeUrl = wxRes.code_url
      const wxOk = [0, '0', 'Succeed', 'SUCCESS'].includes(wxRes.code) && !!codeUrl
      if (wxOk) {
        payQRCode.value = await QRCode.toDataURL(codeUrl, { width: 200 })
        showPayModal.value = true
        startPaymentPolling()
      } else {
        let tip = wxRes.msg || wxRes.message || '获取微信二维码失败'
        if (tip === 'OK' || tip === 'success') {
          tip = '微信统一下单失败，未返回二维码（请核对商户配置；部署新版本后端可显示具体错误原因）'
        }
        ElMessage.error(tip)
      }
    } else if (payMethod.value === 'alipay') {
      const aliRes = await getAlipayParams(res.orderId);
      const formHtml = aliRes.data?.qrCode || aliRes.msg;
      if (aliRes.code === 0 && formHtml) {
        const tempDiv = document.createElement('div');
        tempDiv.id = 'alipay-temp-form-div';
        tempDiv.style.display = 'none';
        tempDiv.innerHTML = formHtml;
        document.body.appendChild(tempDiv);
        const form = tempDiv.querySelector('form');
        if (form) {
          form.method = 'post';
          form.target = '_blank';
          form.submit();
          setTimeout(() => {
            if (tempDiv.parentNode) document.body.removeChild(tempDiv);
          }, 2000);
          startPaymentPolling();
        } else {
          ElMessage.error('支付宝表单异常');
        }
      } else {
        ElMessage.error(aliRes.message || '获取支付宝支付信息失败');
      }
    }
  } catch (e) {
    ElMessage.error(e.message || '支付发起失败');
  }
}

function openPayModal2(card) {
  activeName.value = 'fourth'
  selectedPayCard.value = card
  // 先重置所有卡片的推荐状态
  powerCards.value.forEach(c => c.recommend = false)
  // 设置当前卡片为推荐状态
  //card.recommend = true
  //payCard.value = card
  card.recommend = true
}

function closePayModal() {
  showPayModal.value = false
}

function selectPayCard(card) {
  selectedPayCard.value = card
  powerCards.value.forEach(c => c.recommend = false)
  card.recommend = true
}

// 获取用户信息
onMounted(async () => {

  // 设置页面标题
  document.title = '个人中心'

  const userInfo = await userStore.getUserInfo()
  if (userInfo) {
    userForm.value = { ...userInfo }
  }
  await getPowerCards()
  await getAccountList()
})

onUnmounted(() => {
  stopPaymentPolling()
  if (phoneCountdownTimer) clearInterval(phoneCountdownTimer)
})
</script>

<style scoped>


.personal-center {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  
}

.profile-top-section {
  padding: 30px 30px;
  border-bottom: 1px solid #F3F4F6;
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
  align-items: flex-start;
}

.user-overview {
  margin-top: 20px;
  display: flex;
  gap: 20px;
  align-items: center;
  min-width: 200px;
}

.user-avatar-lg {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #E5E7EB;
  border: 2px solid #fff;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  overflow: hidden;
}

.user-avatar-lg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-meta h2 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 6px;
  color: var(--text-primary);
}

.user-balance {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--el-color-warning);
  font-weight: 600;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.power-icon {
  color: var(--el-color-warning);
}

.btn-clear-cache {
  padding: 6px 12px;
  background: #F3F4F6;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  color: var(--text-secondary);
  font-size: 12px;
  cursor: pointer;
  transition: 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-clear-cache:hover {
  background: #E5E7EB;
  color: var(--text-primary);
}

.recharge-cards-group {
  margin: 6px;
  flex: 1;
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.recharge-card {
  flex: 1;
  min-width: 180px;
  background: #F9FAFB;
  border: 2px solid transparent;
  border-radius: 12px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  overflow: hidden;
  box-shadow: 0 0 0 1px #E5E7EB;
}

.recharge-card.active {
  background:linear-gradient(135deg, #fcf1c5, #f9d79d);
}

.recharge-card:hover{
  background: #fff7d9;
  border: 2px solid var(--el-color-warning);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.15);
}


.power-card-dark {
  background: #374151;
  border: 2px solid transparent;
  border: none;
  color: white;
  display: flex;
  width: 180px;
  flex-direction: column;
  justify-content: center;
}

.rc-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 6px;
}

.rc-tag {
  font-size: 10px;
  padding: 1px 4px;
  border-radius: 4px;
  background: #FEF3C7;
  color: #D97706;
  border: 1px solid #FCD34D;
}

.rc-price {
  font-size: 20px;
  font-weight: 700;
  color: var(--el-color-warning);
  margin: 6px 0;
}

.rc-badge-bottom {
  display: flex;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  margin-top: 4px;
  gap: 4px;
}

.badge-yellow {
  background: var(--el-color-warning);
  color: white;
  padding: 2px 6px;
  border-radius: 20px;
}

.badge-gray {
  background: #E5E7EB;
  color: #6B7280;
}

.tabs {
  margin-top: 10px;
  padding: 0 30px;
}

.account-section {
  background: #fff;
  min-height: 230px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.section-title-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-primary);
}

.filter-bar {
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-width {
  max-width: 480px;
}

.form-width-2 {
  max-width: 500px;
}

.form-container {
  max-width: 480px;
}



.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.form-input-lg {
  width: 100%;
}

.form-input-lg :deep(.el-input__wrapper) {
  padding: 6px 12px;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  background: #F9FAFB;
  transition: 0.2s;
  box-shadow: none;
}

.form-input-lg :deep(.el-input__wrapper:hover) {
  border-color: var(--accent-blue);
}

.form-input-lg :deep(.el-input__wrapper.is-focus) {
  background: #fff;
  border-color: var(--accent-blue);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}



.recharge-cards {
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}


.pay-method-group {
  display: flex;
  gap: 20px;
  align-items: center;
}

.pay-btn-lg {
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}


.scale-user-card {
  margin-top: 60px;
  width: 180px;
  background: #374151;
  color: white;
  padding: 20px;
  border-radius: 12px;
  display: inline-block;
  cursor: pointer;
}

.scale-user-title {
  font-weight: 700;
  font-size: 16px;
  color: #FCD34D;
  margin-bottom: 10px;
}

.scale-user-btn {
  background: #FCD34D;
  color: #374151;
  border: none;
  padding: 6px 12px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
}

.scale-user-btn:hover {
  background: #FBBF24;
}

.avatar-uploader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 1px dashed #D1D5DB;
  background: #F9FAFB;
  cursor: pointer;
  color: var(--text-secondary);
  transition: 0.2s;
}

.avatar-uploader:hover {
  border-color: var(--accent-blue);
  color: var(--accent-blue);
  background: #EEF2FF;
}

.avatar-uploader .avatar {
  margin-right: 0;
  margin-bottom: 0;
  display: block;
  width: 100%;
  height: 100%;
  border: none;
  box-shadow: none;
}

.avatar-uploader-icon {
  font-size: 32px;
  color: var(--text-secondary);
  margin-bottom: 4px;
}

.avatar-uploader-text {
  font-size: 12px;
  margin-top: 4px;
}

.avatar-edit {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 1px dashed #D1D5DB;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-secondary);
  transition: 0.2s;
  position: relative;
  overflow: hidden;
  background: #F9FAFB;
}

.avatar-edit:hover {
  border-color: var(--accent-blue);
  color: var(--accent-blue);
  background: #EEF2FF;
}

.avatar-edit .avatar-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  z-index: 0;
}

.avatar-edit .avatar-icon {
  font-size: 24px;
  margin-bottom: 4px;
  z-index: 1;
  position: relative;
}

.avatar-edit-text {
  font-size: 12px;
  margin-top: 4px;
  z-index: 1;
  position: relative;
  background: rgba(255, 255, 255, 0.9);
  padding: 2px 4px;
  border-radius: 4px;
}

.info-edit-wrap {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}

.userinfo-avatar {
  margin-top: 30px;
  min-width: 120px;
}

.userinfo-form {
  flex: 1;
  max-width: 500px;
}

.info-form {
  flex: 1;
  max-width: 500px;
}



.info-actions {
  margin-top: 30px;
  display: flex;
  gap: 16px;
}



.pay-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  background: #fff;
}

.pay-order {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 16px;
}

.pay-qrcode {
  width: 200px;
  height: 200px;
  border: 1px solid #E5E7EB;
  background: #fff;
  border-radius: 8px;
}

.pay-info {
  font-size: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: var(--text-primary);
}

.pay-amount {
  font-weight: bold;
  margin-top: 8px;
}

.pay-amount-value {
  color: var(--gold-primary);
  font-size: 22px;
}

.pay-tip {
  color: var(--text-secondary);
  font-size: 13px;
  margin-top: 12px;
  text-align: center;
}

.table-scroll-area {
  height: calc(100vh - 210px);
  overflow-y: auto;
}

.pay-method-area {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

.custom-recharge-tip {
  font-size: 13px;
  color: #D97706;
  background: #FFFBEB;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
}

.code-font {
  color: var(--text-secondary);
  font-size: 12px;
}

.amount-minus {
  color: var(--text-primary);
  font-weight: 600;
}

.amount-plus {
  color: #10B981;
  font-weight: 600;
}

.phone-form-group {
  margin-bottom: 20px;
}

.phone-display-row {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 32px;
}

.phone-display-value {
  font-size: 14px;
  color: var(--text-primary, #333);
  min-width: 120px;
}

.phone-code-row {
  display: flex;
  align-items: center;
  width: 100%;
}

/* 滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 3px;
}
</style>
